// extracted by mini-css-extract-plugin
module.exports = {"multiLine-text-wrapper":"MultiLineText_multiLine-text-wrapper__3owxf"};